import { Injectable } from '@angular/core';

export interface InterruptedUploadState {
  tableId: string;
}

export const STORAGE_KEYS = {
  interruptedUpload: 'interruptedUpload',
} as const;

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  readonly keys = STORAGE_KEYS;

  getItem<T>(key: string): T | null {
    try {
      const raw = localStorage.getItem(key);
      if (raw == null) return null;
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  }

  setItem(key: string, value: unknown): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // ignore storage errors
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // ignore
    }
  }

  /** Clears interrupted-upload state if it belongs to the given table (e.g. when dataspace is deleted). */
  clearInterruptedUploadForTable(tableId: string): void {
    const state = this.getItem<InterruptedUploadState>(this.keys.interruptedUpload);
    if (state?.tableId === tableId) {
      this.removeItem(this.keys.interruptedUpload);
    }
  }
}
